export default "__VITE_ASSET__CXWXcevw__"